<template>
    <div data-testid="step-uploadDocument-desktop" class="container">
        <h1
            v-if="!isBadUpload"
            class="container__standard-header"
            v-html="$t(`${translationKey}.UploadPhotoIdentityDocument`)"
        />

        <p v-if="store.state.residenceCountry == 'PL'" class="warning">
            {{ $t(`${translationKey}.headerWarning`) }}
        </p>
        <p v-if="store.state.residenceCountry == 'ES'" class="warning">
            {{ $t(`${translationKey}.spanishHeaderWarning`) }}
        </p>
        <div :class="!isMobile && 'recommended_path_container'">
            <div v-if="!isMobile" class="recommended_header">
                <div class="recommended_header_lines">
                    <div class="line" />
                    <div class="recommended_header_center">
                        <img
                            v-if="!UtilityHelper.isOandaPath()"
                            src="@/assets/phone_icon.svg"
                            alt="phone icon"
                        />
                        <img
                            v-if="UtilityHelper.isOandaPath()"
                            src="@/assets/phone_icon_oanda.svg"
                            alt="phone icon"
                        />
                        <span>{{
                            $t(`${translationKey}.alternatePathLabel`)
                        }}</span>
                    </div>
                    <div class="line" />
                </div>
            </div>

            <p v-if="!isBadUpload" class="container__subheader t-bold t-center">
                {{ $t(`${translationKey}.IDisClear`) }}
            </p>
            <h1
                v-if="isBadUpload"
                class="container__standard-header"
                v-html="$t(`${translationKey}.uploadAgain`)"
            />
            <p v-if="isBadUpload" class="container__subheader t-bold t-center">
                {{ $t(`${translationKey}.uploadAgainInstructions`) }}
            </p>
            <button
                type="button"
                class="photo-examples"
                @click="handleShowPopup"
            >
                <span>?</span>
                {{ $t(`${translationKey}.GoodAndBadPhotoExamples`) }}
            </button>
            <p v-if="isBack" class="front-side-thank-you">
                {{ $t(`${translationKey}.FrontSideThankYou`) }}
            </p>
            <div :class="{ 'manual-upload': isPhotoUpload }">
                <div
                    class="gbg-camera-container desktop-container"
                    :class="{
                        'show-help': showHelp,
                        'show-camera': isShowCamera,
                    }"
                >
                    <HowToTakePicture v-if="showPopup" :is-popup="true" />
                    <div
                        id="gbgContainer"
                        ref="gbgContainer"
                        class="gbgContainer"
                        :class="{
                            'oanda-loader': UtilityHelper.isOandaPath(),
                            'show-loader': showLoader,
                            'photo-upload': isPhotoUpload,
                        }"
                    />
                </div>
            </div>
        </div>
        <div v-if="!isMobile" class="recommended-path-header">
            <img
                v-if="!UtilityHelper.isOandaPath()"
                src="@/assets/phone_icon.svg"
                alt="phone icon"
            />
            <img
                v-if="UtilityHelper.isOandaPath()"
                src="@/assets/phone_icon_oanda.svg"
                alt="phone icon"
            />
            <span>{{
                $t(`${translationKey}.recommendedMobilePathLabel`)
            }}</span>
        </div>
        <button
            v-if="!isMobile"
            type="button"
            class="navigation-link up-mobile"
            @click="handleBackToMobileUpload"
        >
            {{ $t(`${translationKey}.uploadFromMobileButton`) }} »
        </button>
        <p :class="['t-center', { 'is-mobile': isMobile }]">
            {{ $t(`${translationKey}.skipStepReminder`) }}
        </p>
        <button
            type="button"
            class="navigation-link link up-later"
            @click="handleUploadLater"
        >
            {{ $t(`${translationKey}.uploadLaterButton`) }} »
        </button>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import HowToTakePicture from '@/components/steps/HowToTakePicture.vue';
import { UtilityHelper } from '@/helpers/UtilityHelper';
import { useStore } from 'vuex';

export default defineComponent({
    name: 'UploadDocumentFrontDesktopView',

    components: {
        HowToTakePicture,
    },

    props: {
        isBadUpload: Boolean,
        isBack: Boolean,
        isMobile: Boolean,
        isPhotoUpload: Boolean,
        showHelp: Boolean,
        showPopup: Boolean,
        isShowCamera: Boolean,
        showLoader: Boolean,
        translationKey: {
            type: String,
            required: true,
        },
        handleShowPopup: {
            type: Function as PropType<() => void>,
            default: () => {},
        },
        handleBackToMobileUpload: {
            type: Function as PropType<() => void>,
            default: () => {},
        },
        handleUploadLater: {
            type: Function as PropType<() => void>,
            default: () => {},
        },
    },

    setup(props) {
        const store = useStore();

        return {
            UtilityHelper,
            store,
            translationKey: props.translationKey,
        };
    },
});
</script>

<style lang="scss" scoped>
.recommended-path-header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;

    span {
        font-weight: 700;
        font-size: 18px;
    }
}

.navigation-link {
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
}

.recommended_path_container {
    position: relative;
    border: 1px solid #af1919;
    padding: 20px 30px 30px;
    border-top: none;

    &::before {
        content: '';
        position: absolute;
        width: 15%;
        height: 1px;
        background-color: #af1919;
        top: 0;
        left: 0;
    }

    &::after {
        content: '';
        position: absolute;
        width: 15%;
        height: 1px;
        background-color: #af1919;
        top: 0;
        right: 0;
    }

    .recommended_header {
        position: absolute;
        top: -1rem;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 0.25rem;

        .recommended_header_lines {
            display: flex;
            width: 100%;
            align-items: center;

            .line {
                flex: 1;
            }

            .recommended_header_center {
                display: flex;
                align-items: center;
                max-width: 75%;
                padding: 0 1rem;
                text-align: center;
                font-weight: 700;
                font-size: 18px;
                white-space: normal;
                word-break: break-word;
            }
        }
    }

    div.body.oanda & {
        border-color: #00d37e;

        &::before,
        &::after {
            background-color: #00d37e;
        }
    }
}

.up-mobile {
    margin-top: 20px;
    margin-bottom: 40px;
}
.is-mobile {
    margin-top: 20px;
}

.warning {
    text-align: center;
    margin-bottom: 30px;
}
</style>
